import { params } from "@/params";
import { v4 as uuid } from "uuid";

export const useRetryResponse = () => {
  const retryWithSuggestions = async ({
    suggestedMemories = [],
    suggestedSnippets = [],
    tenant,
    messagesWithoutLast,
  }: {
    suggestedMemories: any[];
    suggestedSnippets: any[];
    tenant: string;
    messagesWithoutLast: any[];
  }) => {
    try {
      const formattedMemories = suggestedMemories.map((memory) => ({
        id: memory.id || uuid(),
        text: memory.data,
        impact: memory.impact,
      }));

      const formattedSnippets = suggestedSnippets.map((snippet) => ({
        id: snippet.id || uuid(),
        text: snippet.data,
      }));

      const response = await fetch(
        `${params.AI_URL}/api/simulate-reply/tickets?stream=false`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tenantId: tenant,
            messages: messagesWithoutLast,
            newMemories: formattedMemories,
            newSnippets: formattedSnippets,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data?.text;
    } catch (error) {
      console.error("Error in retryWithSuggestions:", error);
      return null;
    }
  };

  return { retryWithSuggestions };
};
